/*
 * @Author: DaLong Li
 * @Date: 2025-02-21 10:49:38
 * @LastEditTime: 2025-02-21 10:54:50
 * @LastEditors: DaLong Li
 * @Description: 
 * 生命在于运动，代码在于抽动。
 */
import { createI18n } from 'vue-i18n';
import ZH from './locale/zh.js';
import EN from './locale/en.js';
import JA from './locale/ja.js';

const messages = {
    zh: ZH,
    en: EN,
    ja: JA
};

const i18n = createI18n({
    legacy: false,
    locale: 'zh',
    fallbackLocale: 'zh',
    messages,
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    missingWarn: false,
    fallbackWarn: false
});

export default i18n;
